/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VcdsOrgPatchSpec { 
    /**
     * The VCDS org type
     */
    org_type?: string;
    /**
     * Reset the org type overridden flag and recompute VCDS Org type (based on VMC Org type)
     */
    org_type_reset?: boolean;
}

